var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.packages && _vm.packages.length > 0)?_c('div',{staticClass:"you-may-also-like"},[_c('ymal-header',{attrs:{"content":_vm.content}}),_vm._v(" "),_c('div',{staticClass:"row hidden-xs"},[_c('package-carousel',{attrs:{"packages":_vm.packages}})],1),_vm._v(" "),_c('div',{staticClass:"row visible-xs"},[_c('package-listing',{attrs:{"packages":_vm.packages}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16928d58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/shared/components/catalog/YouMayAlsoLike/YouMayAlsoLike.vue
// module id = 875
// module chunks = 0 2